export const API_URL = "https://admin.drhemakrishnaneuro.com/api/client/";
export const ASSETS_URL = "https://admin.drhemakrishnaneuro.com/";
export const GOOGLE_MAP_IFRAME =
  "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3888.247867537946!2d77.71439427507616!3d12.955984787357945!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTLCsDU3JzIxLjYiTiA3N8KwNDMnMDEuMSJF!5e0!3m2!1sen!2sin!4v1748394863024!5m2!1sen!2sin";
// export const API_URL="";
